export default {
    'ModalFlujos.CrearFlujo': 'Crear Flujo',
    'ModalFlujos.EditarFlujo': 'Editar Flujo',
    //'sidebar.flujoetapas': 'Flujo Etapas',
};
